import { render } from "./Aluno.vue?vue&type=template&id=45c5171e"
import script from "./Aluno.vue?vue&type=script&lang=js"
export * from "./Aluno.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__